import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assests/AS1.png'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (
    <header id='home'>
      <div className='container header__container'>
        <h5>Hey! I am</h5>
        <h1>Abdullah Sattar</h1>
        <h3 className='text-light'>Senior Software Engineer</h3>
        <h5 className='text-light'>Google Speaker | Author</h5>
        <CTA/>
        <HeaderSocials/>

        <div className="me">
          <img src={ME} alt="me" />
          
        </div>
        <a href='#contact' className='scroll__down'>Scroll Down</a>
        

      </div>
    </header>
  )
}

export default Header